import React, { createContext, useState, useEffect, useContext } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => {
        // Run this function ONLY on initial render
        const savedTheme = localStorage.getItem('theme');
        if (savedTheme) {
            return savedTheme;
        }
        // Fallback to OS preference
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        return prefersDark ? 'dark' : 'light';
    });
    const [accentColor, setAccentColor] = useState(null);

    useEffect(() => {
        const savedAccent = localStorage.getItem('accentColor');

        if (savedAccent) {
            setAccentColor(savedAccent);
        }
    }, []);

    useEffect(() => {
        document.body.className = theme === 'light' ? 'light-mode' : '';
        localStorage.setItem('theme', theme);
    }, [theme]);

    useEffect(() => {
        const root = document.body;
        const html = document.documentElement; // Ensure we clean up previous legacy

        // Always clean the html tag just in case of stale state from previous implementation
        html.style.removeProperty('--accent-color');

        if (accentColor) {
            root.style.setProperty('--accent-color', accentColor);
            localStorage.setItem('accentColor', accentColor);
        } else {
            root.style.removeProperty('--accent-color');
            localStorage.removeItem('accentColor');
        }
    }, [accentColor]);

    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === 'dark' ? 'light' : 'dark'));
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme, accentColor, setAccentColor }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);
